// ------------------------------------------------------
// JS POUR LES BLOCS DANS GUTEMBERG
// à  compiler avec webpack
// aller dans le dossier /webpack pour plus d'infos
// ------------------------------------------------------

import $ from 'jquery';
// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay, Thumbs } from '/node_modules/swiper';
// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay, Thumbs]);

import './gutemberg/slider-programme.js';
import './gutemberg/slider-gallery.js';
import './gutemberg/slider-coach.js';
import './gutemberg/slider-trust.js';



$(function () {

	// ---------------------
	// Slider programme  : slider-programme
	//---------------------

	//sur le front
	$('.slider-programme .swiper').each(function () {
		$(this).sliderAcfProgramme();
	});


	// Initialize dynamic block preview (editor gutemberg).
	if (window.acf) {
		var initSliderProgramme = function ($block) {
			var blocSlider = $block.find('.slider-programme .swiper');
			$(blocSlider[0]).sliderAcfProgramme();
		}

		$('.slider-programme .swiper').each(function () {
			initSliderProgramme($(this));
		});

		// pass the name of gutemberg bloc in type=
		window.acf.addAction('render_block_preview/type=slider-programme', initSliderProgramme);
	}


	// ---------------------
	// Slider coach : slider-coach
	//---------------------

	//sur le front
	$('.slider-coach').each(function () {
		let nav = $(this).find('.coachNavSwiper');
		let slider = $(this).find('.coachSwiper');

		var navigationSwiper = new Swiper(nav[0], {
			slidesPerView: 10,
			spaceBetween: 10,
			freeMode: true,
			watchSlidesProgress: true,
			touchRatio: 0.2,
			slideToClickedSlide: true,
		});




		var coachSwiper = new Swiper(slider[0], {
			spaceBetween: 20,
			slideToClickedSlide: true,
			touchRatio: 0.2,
			autoplay: {
				delay: 5000,
			},
	
			thumbs: {
				swiper: navigationSwiper,
			},


			breakpoints: {
				993: {
					slidesPerView: 1,
					spaceBetween: 0,
					navigation: false
				},
			},
			loop: true,
		});

	});

	// Initialize dynamic block preview (editor gutemberg).
	if (window.acf) {
		var initSliderCoach = function ($block) {

			let nav = $block.find('.coachNavSwiper');
			let slider = $block.find('.coachSwiper');

			var navigationSwiper = new Swiper(nav[0], {
				slidesPerView: 10,
				spaceBetween: 10,
				freeMode: true,
				watchSlidesProgress: true,
				touchRatio: 0.2,
				slideToClickedSlide: true,
			});

			var coachSwiper = new Swiper(slider[0], {
				spaceBetween: 20,
				slideToClickedSlide: true,
				touchRatio: 0.2,
				autoplay: {
					delay: 5000,
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				thumbs: {
					swiper: navigationSwiper,
				},


				breakpoints: {
					993: {
						slidesPerView: 1,
						spaceBetween: 0,
						navigation: false
					},
				},
				loop: true,
			});

		}

		$('.slider-coach').each(function () {
			initSliderCoach($(this));
		});
		// pass the name of gutemberg bloc in type=
		window.acf.addAction('render_block_preview/type=slider-coach', initSliderCoach);
	}


	// ---------------------
	// Slider coach custom : slider-coach-custom
	//---------------------

	const coachCustom = '.slider-coach-custom .swiper' ;
	$(coachCustom).each(function () {
		$(this).sliderAcfCoach();
	});


	// Initialize dynamic block preview (editor gutemberg).
	if (window.acf) {
		var initSliderCoach = function ($block) {
			var blocSlider = $block.find(selecteur);
			console.log( blocSlider );
			$(blocSlider[0]).sliderAcfCoach();
		}

		$(coachCustom).each(function () {
			initSliderCoach($(this));
		});

		// pass the name of gutemberg bloc in type=
		window.acf.addAction('render_block_preview/type=slider-coach-custom', initSliderCoach);
	}


	// ---------------------
	// Slider gallery : slider-gallery
	//---------------------

	const selecteur = '.slider-gallery .swiper' ;
	$(selecteur).each(function () {
		$(this).sliderAcfGallery();
	});

	// ---------------------
	// Slider gallery : slider-gallery
	//---------------------

	const selecteurTrust = '.trust .swiper' ;
	$(selecteurTrust).each(function () {
		$(this).sliderAcfTrust();
	});


	// Initialize dynamic block preview (editor gutemberg).
	if (window.acf) {
		var initSliderGallery = function ($block) {
			var blocSlider = $block.find(selecteur);
			console.log( blocSlider );
			$(blocSlider[0]).sliderAcfGallery();
		}

		$(selecteur).each(function () {
			initSliderGallery($(this));
		});

		// pass the name of gutemberg bloc in type=
		window.acf.addAction('render_block_preview/type=slider-gallery', initSliderGallery);
	}

	// on the front


	if ($('.page-template-template-free')) {
	

		// Team List Slider

		/* Swiper
		**************************************************************/
		if ($('.team-members-container').length > 0) {

			var teamSwiper = null; //Swiper;
			var init = false;


			/* Which media query
			**************************************************************/
			function swiperMode() {
				let mobile = window.matchMedia('(min-width: 0px) and (max-width: 768px)');
				let tablet = window.matchMedia('(min-width: 769px) and (max-width: 1024px)');
				let desktop = window.matchMedia('(min-width: 1025px)');

				// Enable (for mobile)
				if (mobile.matches) {
					if (!init) {
						init = true;
						teamSwiper = new Swiper('.team-members-container', {
							slidesPerView: 1,
							autoplay: {
								delay: 5000,
								disableOnInteraction: false,
							},
							centeredSlides: true,
							loop: true,
							spaceBetween: 25,
							direction: 'horizontal',
							effect: 'coverflow',

							coverflowEffect: {
								rotate: 0,
								stretch: 0,
								depth: 0,
								modifier: 0,
								slideShadows: false,
							},

							breakpoints: {

								769: {
									slidesPerView: 1,
									spaceBetween: 0,
									effect: 'coverflow',

									coverflowEffect: {
										rotate: 0,
										stretch: 20,
										depth: 120,
										modifier: 3,
										slideShadows: false,
									}
								}

							}

						});
					}

				}

				// Disable (for tablet)
				else if (tablet.matches && init) {
					if (teamSwiper !== undefined) teamSwiper.destroy();
					init = false;
				}

				// Disable (for desktop)
				else if (desktop.matches && init) {
					if (teamSwiper !== undefined) teamSwiper.destroy();
					init = false;
				}
			}

			/* On Load
			**************************************************************/
			window.addEventListener('load', function () {
				swiperMode();
			});

			/* On Resize
			**************************************************************/
			window.addEventListener('resize', function () {
				swiperMode();
			});

		}

	}


});




//---- ce code créer des spacers prédéfinis en taille, définir également des styles avant -----------------

const spacerInspectorControls = wp.compose.compose(

	wp.compose.createHigherOrderComponent((BlockEdit) => {
		return (props) => {

			if (props.name !== 'core/spacer') {
				return (<BlockEdit {...props} />);
			}

			const { attributes } = props;

			if (attributes.className == 'is-style-spacer-1') {
				attributes.height = 10;
			}

			if (attributes.className == 'is-style-spacer-2') {
				attributes.height = 20;
			}

			if (attributes.className == 'is-style-spacer-3') {
				attributes.height = 30;
			}

			if (attributes.className == 'is-style-spacer-4') {
				attributes.height = 40;
			}

			if (attributes.className == 'is-style-spacer-5') {
				attributes.height = 50;
			}

			if (attributes.className == 'is-style-spacer-6') {
				attributes.height = 60;
			}

			return (<BlockEdit {...props} />);
		};
	}, 'spacerInspectorControls'));

wp.hooks.addFilter(
	'editor.BlockEdit',
	'awp/spacer-inspector-control',
	spacerInspectorControls
);

